import React from "react";
import {t} from "../../../helpers/translator";
import CountDownComponent from "../countDownClock";

export default function loyalCardPopup () {
    return (
        <React.Fragment>
            <div className="ticket-results-view-p">
            <CountDownComponent second={30}/>
            <h3>{t(`Card is already applied`)}</h3>
            <button onClick={this.deleteTheCard} className='button-view-normal-m'>{t(`Delete the card`)}</button>
            </div>
        </React.Fragment>
    );
}